import { Base, Component, Prop } from '@/vue-property-decorator'
import { Button } from '@/plugins/ant-design-vue/tsx-support'
import { isUrl } from '@/utils/Tool'
import { useFooterStore } from '../../store'
import { windowOpen } from '@/utils/business-utils'
import AppTypes from '@/vue-types'
import style from './style.module.scss'

export interface Props {
  long?: number
  showTitle?: boolean
}

/**h5专用logoarea(合作方信息) */
@Component<LogoArea>({
  name: 'LogoArea'
})
export default class LogoArea extends Base {
  @Prop(AppTypes.number.def(38))
  private readonly long!: Props['long']
  store = useFooterStore()

  private get footerInfos() {
    return this.store.footerInfos
  }
  render() {
    const logList = this.footerInfos?.partnerInfo || []
    if (this.footerInfos?.partnerInfoStatus) {
      return <template></template>
    }
    return (
      <div class={[style.logoArea, 'logo-area']}>
        {logList.map((item, index) => {
          return (
            <Button.Tsx
              key={index}
              type={'link'}
              onClick={() => {
                if (item.partnerLink) {
                  if (isUrl(item.partnerLink)) {
                    windowOpen(item.partnerLink)
                  }
                }
              }}
              class={[style.linkBtn, 'logo-link']}
            >
              <my-img height={this.long} src={item.partnerImage} />
            </Button.Tsx>
          )
        })}
      </div>
    )
  }
}
